import React from 'react'
import useContactContext from 'pages/newContacts/hooks/useContactContext'

const BuyerBrokerFilter = () => {
  const { state, applyBuyerFilter, applyBrokerFilter } = useContactContext()

  return (
    <div className='w-full flex flex-row'>
        <div onClick={() => applyBuyerFilter()} className={`flex flex-1 justify-center border-2 border-softBlack border-r-0 p-2 cursor-pointer ${state.contactUserType === 'Buyer' ? 'bg-softBlack text-white' : ''}`}>Buyer</div>
        <div onClick={() => applyBrokerFilter()} className={`flex flex-1 justify-center border-2 border-softBlack p-2 cursor-pointer ${state.contactUserType === 'LeadBroker' ? 'bg-softBlack text-white' : ''}`}>Broker</div>
    </div>
  )
}

export default BuyerBrokerFilter
